import { useEffect, useState } from "react";
import { createInvestment } from "./InvestmentService";
import { apiFetch } from "../../api";
import { getAllAccounts } from "../accounts/AccountService";

export default function RDForm(){

  const [accounts,setAccounts] = useState([]);
  const [form,setForm] = useState({
    investmentType:"RD",
    accountId:"",
    name:"",
    provider:"",
    principal:"",
    interestRate:"",
    startDate:"",
    durationMonths:"",
    nextDebitDate:""
  });

  useEffect(()=>{
    loadAccounts();
  },[]);

  const loadAccounts = async ()=>{
    setAccounts(await getAllAccounts());
  };

  const submit = async (e)=>{
    e.preventDefault();
    await createInvestment(form);
    alert("RD Created");
  };

  return (
    <div className="card">
      <div className="card-title">Create Recurring Deposit (RD)</div>

      <form onSubmit={submit} className="form-grid">

        <select className="input" onChange={e=>setForm({...form,accountId:e.target.value})}>
          <option value="">Select Account</option>
          {accounts.map(a=><option key={a.id} value={a.id}>{a.accountName}</option>)}
        </select>

        <input className="input" placeholder="RD Name"
          onChange={e=>setForm({...form,name:e.target.value})} />

        <input className="input" placeholder="Bank / Provider"
          onChange={e=>setForm({...form,provider:e.target.value})} />

        <input className="input" type="number" placeholder="Monthly Amount"
          onChange={e=>setForm({...form,principal:e.target.value})} />

        <input className="input" type="number" placeholder="Interest Rate %"
          onChange={e=>setForm({...form,interestRate:e.target.value})} />

        <input className="input" type="date"
          onChange={e=>setForm({...form,startDate:e.target.value})} />

        <input className="input" type="number" placeholder="Duration (months)"
          onChange={e=>setForm({...form,durationMonths:e.target.value})} />

        <input className="input" type="date" placeholder="Next Debit Date"
          onChange={e=>setForm({...form,nextDebitDate:e.target.value})} />

        <div className="form-full" style={{ textAlign:"right" }}>
          <button className="btn btn-primary">Create RD</button>
        </div>

      </form>
    </div>
  );
}
